var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout"},[_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer",function(){return [_c('page-footer')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }